import { render, staticRenderFns } from "./InvitDatails.vue?vue&type=template&id=0a959b3c&scoped=true"
import script from "./InvitDatails.vue?vue&type=script&lang=js"
export * from "./InvitDatails.vue?vue&type=script&lang=js"
import style0 from "./InvitDatails.vue?vue&type=style&index=0&id=0a959b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a959b3c",
  null
  
)

export default component.exports